import dayjs from "dayjs";
import { CORE_API } from "../constants";
import { getAccessToken, getData } from "./common.service";


class NutrientReportService {
  private static readonly baseUrl = "/nutrient-reports";

  static getPlotNutrientReports(plotId: string) {
    const filterQuery = {
      where: {
        plotId: plotId,
      },
      limit: 10,
      order: ["date DESC"],
    };

    const url = `${NutrientReportService.baseUrl}?filter=${JSON.stringify(
      filterQuery
    )}`;

    return getData(url, {
      sendTokenInHeader: true,
      basePath: CORE_API,
    });
  }

  static getNutrientsReportPDF(reportId: string) {

    const url = `${CORE_API}/${NutrientReportService.baseUrl}/${reportId}/pdf`;
    const headers = new Headers({
      "content-type":"text/plain",
      Authorization:`Bearer ${getAccessToken()}`,
    });

    const requestOptions = {
      method: "GET", 
      headers: headers,
    };
    const fileName = "Fyllo" + dayjs().format("YYYY-MM-DD") + ".pdf";

    fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(data=>{
        // downloading file using <a/> tag
        const link = document.createElement("a");
        link.href = data; 
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        return data;
      })
      .catch((error) => {
        console.log(error);
        window.alert("Error fetching or processing the PDF");
      });

  }

  static deleteNutrientReport(reportId: string) {
    const url = `${NutrientReportService.baseUrl}/${reportId}`;

    fetch(CORE_API + url, {
      method: "DELETE",
      headers: new Headers({
        Authorization: "Bearer " + getAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      }),
    })
      .then(res => {
        console.log(res.status);
        return res;
      })
      .then(res => {
        console.log(res);
        return res;
      });
  }

}

export default NutrientReportService;